import { gql } from 'apollo-angular';

export const RemoveOutputDataDocument = gql`
  mutation removeOutputData($outputDataId: Int!) {
    removeOutputData(outputDataId: $outputDataId)
  }
`;
